import React from 'react';
import { collaboratorTypes } from './collaborator.constant';
import Statistics from './Statistics';

const EngineerStats = () => {
    return (
        <Statistics userType={collaboratorTypes.INGENIEUR} />
    );
};

export default EngineerStats;